@switch (getType(commandContentEntry())) {
  @case ('object') {
    <div>
      <ul class="list-unstyled pl-0">
        @for (entry of toObject(commandContentEntry()) | keyvalue; track entry) {
          <li>
            <b>{{ entry.key }}:</b>
            <ml-timeline-command-payload [commandContentKey]="entry.key"
                                         [commandContentEntry]="entry.value"></ml-timeline-command-payload>
          </li>
        }
      </ul>
    </div>
  }
  @case ('object-in-array') {
    <div>
      <ml-timeline-command-payload
                                   [commandContentEntry]="firstArrayItem(commandContentEntry())"></ml-timeline-command-payload>
    </div>
  }
  @case ('array') {
    <div>
      <ul class="row">
        @for (item of toArray(commandContentEntry()); track item) {
          <li class="col-md-7 col-lg-6">
            <ml-timeline-command-payload [commandContentEntry]="item"></ml-timeline-command-payload>
          </li>
        }
      </ul>
    </div>
  }
  @case ('image') {
    <div>
      <img class="img-fluid w-50 h-50 d-block"
           [src]="formatImage(toString(commandContentEntry()))"
           [alt]="toString(commandContentEntry())" />
    </div>
  }
  @case ('profilepayload') {
    <div>
      <ml-timeline-command-payload
                                   [commandContentEntry]="parsePlist(decode(toString(commandContentEntry())))"></ml-timeline-command-payload>
    </div>
  }
  @case ('default') {
    <div>
      {{ commandContentEntry() }}
    </div>
  }
}